var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{attrs:{"loading":"","type":"table","types":{ 'table-tbody': 'table-row-divider@5', 'table-row': "table-cell@1", 'table-thead': "", 'table-heading': '', 'table-tfoot': ''}}})}
var staticRenderFns = []

export { render, staticRenderFns }